export const prefixClsForm = 'xUi-form';
export const prefixClsFormItem = 'xUi-form-item';
export const prefixClsEmpty = 'xUi-empty';
export const prefixClsInput = 'xUi-input';
export const prefixClsSelect = 'xUi-select';
export const prefixClsCheckbox = 'xUi-checkbox';
export const prefixClsSwitch = 'xUi-switch';
export const prefixClsRadio = 'xUi-radio';
export const prefixClsTextArea = 'xUi-textarea';
export const prefixClsUpload = 'xUi-upload';
export const prefixClsDatePicker = 'xUi-datepicker';
export const prefixClsRangePicker = 'xUi-rangepicker';
export const prefixClsTimePicker = 'xUi-timepicker';
export const prefixClsButton = 'xUi-button';
export const prefixClsSkeleton = 'xUi-skeleton';

export const prefixClsFormV3 = 'v3-form';
export const prefixClsFormItemV3 = 'v3-form-item';
export const prefixClsEmptyV3 = 'v3-empty';
export const prefixClsInputV3 = 'v3-input';
export const prefixClsSelectV3 = 'v3-select';
export const prefixClsCheckboxV3 = 'v3-checkbox-input';
export const prefixClsSwitchV3 = 'v3-switch';
export const prefixClsRadioV3 = 'v3-radio';
export const prefixClsTextAreaV3 = 'v3-textarea';
export const prefixClsButtonV3 = 'v3-btn';
export const prefixClsUploadV3 = 'v3-upload';

// non updates
export const prefixClsSkeletonV3 = 'v3-skeleton';
export const prefixClsDatePickerV3 = 'v3-datepicker';
export const prefixClsRangePickerV3 = 'v3-rangepicker';
export const prefixClsTimePickerV3 = 'v3-timepicker';
